/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DiagnosisLetters/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import GenerateLettersModal from 'DesignSystem/GenerateLettersModal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DiagnosisLetters({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Secondary/DiagnosisAction/Content/Diagnosis/DiagnosisLetters"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: '_id',
})
let eventAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.id',
})
let eventAppointmentBookingIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.id',
})
let preselectedLettersValueData = fromData.useDataValue({ viewPath,
context: 'preselected_letters',
})
  return (<React.Fragment
>
<GenerateLettersModal
  viewPath={`${viewPath}/GenerateLettersModal`}
 data="patient._id"
 patientId={patientIdValueData}
 data="event.appointment.id"
 appointmentId={eventAppointmentIdValueData}
 data="event.appointment.booking.id"
 bookingId={eventAppointmentBookingIdValueData}
 data="preselected_letters"
 letters={preselectedLettersValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
{children}
</React.Fragment>)
}